export function stripHtmlEscapeCharactersFromURL(url: string): string {
  if (!url) return url;
  const replaceMap = {
    '&amp;': '&',
  };
  return url.replace(/&amp;/g, (match) => replaceMap[match]);
}
